import React from 'react';
import { Card, CardContent, Typography, Grid, makeStyles } from '@material-ui/core';



const Image = 'https://i.imgur.com/4LnPljT.jpeg';

const useStyles = makeStyles((theme) => ({
  card: {
    position: 'relative',
    width: '100%',
    margin: 'auto',
    marginTop: theme.spacing(4),
    padding: theme.spacing(2),
    height: 'auto',
    overflow: 'hidden',
  },
  backgroundImage: {
    content: "''",
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundImage: `url(${Image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    opacity: '50%',
  },
  backgroundColorLayer: {
    backgroundColor: 'rgba(47, 94, 168, 0.7)',
    width: '100%',
    height: '100%',
    position: 'absolute',
    opacity: '70%',
    top: 0,
    left: 0,
    zIndex: 1
  },
  icon: {
    fontSize: 40,
    color: 'white',
    width: '55px',
    height: '55px',
    zIndex: 2
  },
  title: {
    marginTop: theme.spacing(1),
    textAlign: 'center',
    color: 'white',
    margin: '20px',
    zIndex: 2
  },
  header: {
    marginTop: theme.spacing(1),
    textAlign: 'center',
    color: '#fff',
  },
}));

const CitizenFacilitation = () => {
  const classes = useStyles();

  const iconData = [
    { icon: <img src='https://i.imgur.com/m4QnIck.png' className={classes.icon} />, title: 'Notified Planning/Special Area' },
    { icon: <img src='https://i.imgur.com/0qU2lat.png' className={classes.icon} />, title: 'RTI' },
    { icon: <img src='https://i.imgur.com/gAdiHIh.png' className={classes.icon} />, title: 'Regitered Estate Agent' },
    { icon: <img src='https://i.imgur.com/G0ZeisD.png' className={classes.icon} />, title: 'Registered Promoters' },
    { icon: <img src='https://i.imgur.com/49sZB4N.png' className={classes.icon} />, title: 'Directory of Registered Proffessionals' },
    { icon: <img src='https://i.imgur.com/64dfsol.png' className={classes.icon} />, title: 'Download Forms' },
    { icon: <img src='https://i.imgur.com/2RI9Vr4.png' className={classes.icon} />, title: 'Public Service Guarantee Act' },
    { icon: <img src='https://i.imgur.com/Fmq7Rqx.png' className={classes.icon} />, title: 'License and Essentiality Certificates' },
    { icon: <img src='https://i.imgur.com/cEmJalq.png' className={classes.icon} />, title: 'Planning Permission case' },
    { icon: <img src='https://i.imgur.com/rLZI0Jx.png' className={classes.icon} />, title: 'Instruction/Orders' },
    { icon: <img src='https://i.imgur.com/TqMvq5G.png' className={classes.icon} />, title: 'Area Locator' },
    { icon: <img src='https://i.imgur.com/eDXNkGq.png' className={classes.icon} />, title: 'Unauthorized Construction' },
  ];

  return (
    <Card className={classes.card}>
      <div className={classes.backgroundImage}></div>
      <div className={classes.backgroundColorLayer}></div>
      <CardContent>
        <Typography variant="h6" className={classes.header} style={{textAlign: 'center', color: '#fff', fontSize: '30px'}}>
          Citizen Facilitation
        </Typography>

        <Grid container spacing={2} justifyContent="center" alignItems='center' alignContent='center'>
          {iconData.map((item, index) => (
            <Grid item key={index} xs={6} sm={4} md={3} lg={2}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {item.icon}
                <Typography variant="subtitle1" className={classes.title}>
                  {item.title}
                </Typography>
              </div>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CitizenFacilitation;
